import { TNotification } from '../../../types/notifications';
import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { EGetNotificationsListActionTypes, TGetNotificationsListSucceed } from './types';

export const getNotificationsListSucceed: (notifications: TNotification[]) => TGetNotificationsListSucceed =
  actionGenerator<EGetNotificationsListActionTypes.Succeed, TNotification[]>(EGetNotificationsListActionTypes.Succeed);
